import { Component, OnDestroy } from '@angular/core';
import { Appointment } from 'src/app/core/models/appointment.model';

@Component({
	selector: 'app-appointment-details',
	templateUrl: './appointment-details.component.html',
	styleUrls: ['./appointment-details.component.scss'],
})
export class AppointmentDetailsComponent implements OnDestroy {

	pageTitle = 'Details';

	appointment: Appointment;
	hiddenSections = [0];

	constructor() { }

	setAppointment(appointment: Appointment) {
		this.appointment = appointment;
	}

	ngOnDestroy() {
		this.hiddenSections = [0];
	}

	onClickToggleSection(sectionIndex: number) {
		const foundIndex = this.hiddenSections.findIndex(index => index === sectionIndex);
		if (foundIndex === -1) {
			this.hiddenSections.push(sectionIndex);
			return;
		}

		this.hiddenSections.splice(foundIndex, 1);
	}

	isVisible(sectionIndex: number) {
		return (this.hiddenSections.findIndex(index => index === sectionIndex) > -1);
	}

}
